export default __webpack_public_path__ + "static/media/chim6.85c50086.webp";